import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  Grid,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
} from '@mui/material';
import {
  Room,
  LocalGasStation,
  Map,
  Call,
  DirectionsCar,
  Fingerprint,
} from '@mui/icons-material';
import IntlMessages from '../../../util/IntlMessages';
import useStyles from './bottom_content.style';
import * as tools from '../../../util/tools';
import ButtonAction from './button_action';
import PaymentType from './payment_type';
import Navigation from './navigation';

function BottomContent(props) {
  const classes = useStyles();
  let requestDetails = props.field.requestOnline;
  const [navigation, setNavigation] = useState(false);

  return (
    <React.Fragment>
      <Card className={classes.root}>
        <Grid className={classes.header} container>
          <Grid item xs={6} md={6} className={classes.routing}>
            <Button
              href={
                'geo:' +
                requestDetails.location.dLatitude +
                ',' +
                requestDetails.location.dLongitude
              }
              variant="outlined"
              color="inherit"
              startIcon={<Map />}
              size="small"
            >
              <IntlMessages id="routing" />
            </Button>
          </Grid>
          <Grid item xs={6} md={6} className={classes.contactUser}>
            <Button
              href={tools.telFormat(requestDetails.vCustomerMobileNumber)}
              variant="outlined"
              color="inherit"
              startIcon={<Call />}
              size="small"
            >
              <IntlMessages id="contactUser" />
            </Button>
          </Grid>
        </Grid>
        <List dense={true}>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={{ width: 35, height: 35 }}>
                <Room fontSize="small" />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={<IntlMessages id="address" />}
              secondary={requestDetails.location.vAddress}
            />
          </ListItem>
          <Grid container>
            <Grid item xs={5} md={5}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ width: 35, height: 35 }}>
                    <LocalGasStation fontSize="small" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<IntlMessages id="litrage" />}
                  secondary={
                    <>
                      {tools.numberformat(
                        requestDetails.iVolumeReceived === 0
                          ? requestDetails.iVolumeRequested
                          : requestDetails.iVolumeReceived,
                      )}
                      <IntlMessages id="liter" />
                    </>
                  }
                />
              </ListItem>
            </Grid>
            <Grid item xs={7} md={7}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ width: 35, height: 35 }}>
                    <Fingerprint fontSize="small" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<IntlMessages id="requestCode" />}
                  secondary={<>{requestDetails.vRequestCode}</>}
                />
              </ListItem>
            </Grid>
          </Grid>
          <ListItem>
            <ListItemAvatar>
              <Avatar sx={{ width: 35, height: 35 }}>
                <DirectionsCar fontSize="small" />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={<IntlMessages id="userCar" />}
              secondary={requestDetails.licensePlate[0].vNameCar}
            />
          </ListItem>
        </List>
        <PaymentType requestDetailsFunc={() => props.requestDetailsFunc()} />
        <ButtonAction />
        <Navigation
          latitude={requestDetails.location.dLatitude}
          longitude={requestDetails.location.dLongitude}
          navigation={navigation}
          setNavigation={(status) => setNavigation(status)}
        />
      </Card>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    field: state.field,
  };
};

export default connect(mapStateToProps)(BottomContent);
